import { render, staticRenderFns } from "./singleDivision.vue?vue&type=template&id=fc8f7010&scoped=true&"
import script from "./singleDivision.vue?vue&type=script&lang=js&"
export * from "./singleDivision.vue?vue&type=script&lang=js&"
import style0 from "./singleDivision.vue?vue&type=style&index=0&id=fc8f7010&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8f7010",
  null
  
)

export default component.exports